export default {
  allowConnectToDB: true,
};
